import axiosInstance from "../../Axios/axiosInstance";
import NovaAPI from "../../Axios/NovaAPI";
import { setLoggingOutUser } from "../../Store/Login/loginActions";
import { store } from "../../Store/store";
import { localeMap } from "../../consts/constant";

export const changePassword = async (newPasword, currentPassword) => {
  let response = { data: null, error: "" };
  const apiData = {
    newPassword: newPasword || "",
    oldPassword: currentPassword || "",
  };
  try {
    response.data = await axiosInstance.put(`/user/auth/change-password`, {
      ...apiData,
    });
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const updateUserDetails = async (userDetails) => {
  let response = { data: null, error: "" };
  try {
    response.data = await axiosInstance.patch(`/user/me`, {
      ...userDetails,
    });
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const supportEmail = async (subject, message) => {
  let response = { data: null, error: "" };
  const supportEmailData = { subject: subject || "", message: message || "" };
  try {
    response.data = await axiosInstance.post(
      `/notification/notifications/support-request`,
      {
        ...supportEmailData,
      },
    );
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const destroyToken = async () => {
  let response = { date: null, error: "" };
  try {
    store.dispatch(setLoggingOutUser(true));
    response.data = await NovaAPI.post(`/user/auth/logout`, {});
    store.dispatch(setLoggingOutUser(false));
  } catch (err) {
    response.error = err.response;
    store.dispatch(setLoggingOutUser(false));
  }
};

export const deleteUserAccountApi = async ({ consent }) => {
  let response = { date: null, error: "" };
  try {
    response.data = await axiosInstance.patch(
      `/user/me/delete?consent=${consent ? consent : false}`,
      {},
    );
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const updateLanguagePreference = async (language) => {
  let response = { data: null, error: "" };
  try {
    response.data = await axiosInstance.patch(`/user/me/preferences`, {
      languagePreferred: localeMap(language),
    });
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const updateInsuranceCards = async ({
  appUserId,
  insuranceDetails,
  isFamilyMember,
}) => {
  const payload = {
    appUserId,
    insuranceDetails,
    isFamilyMember,
  };
  let response = { date: null, error: "" };
  try {
    response.data = await axiosInstance.patch(`/user/me`, payload);
  } catch (err) {
    response.error = err.response;
  }
  return response;
};
